import { render } from "./AccountDefaultDetail.vue?vue&type=template&id=6e5160bc&scoped=true"
import script from "./AccountDefaultDetail.vue?vue&type=script&lang=js"
export * from "./AccountDefaultDetail.vue?vue&type=script&lang=js"

import "./AccountDefaultDetail.vue?vue&type=style&index=0&id=6e5160bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5160bc"]])

export default __exports__